export default __webpack_public_path__ + "static/media/menu_my_images_okara.47e5d51f.svg";